<ng-container>

  <div class="modal-body printPreview" [hidden]="hidePrintExport">
    <jt-modal-page [defaultHide]="'true'">
      <app-jt-modal-hor-form [formConfig]="modalConfig">
        <form-actions data-testid="form-action-buttons">
          <button aria-hidden="true" data-testid="btn-export-to-excel" id="btnExporttoExcel" attr.data-file-name="{{fileName}}" onclick="exportToExcel()" class="hidden btnExporttoExcel btn btn-primary form-group" type="button">{{ 'Common.ExportToExcel' | translate }}</button>
          <button class="btn btn-primary form-group btn_exportWord" data-testid="btn-export-to-word" onclick="exportToWord()">
            {{ 'Common.ExportToWord' | translate }}
          </button>
          <button class="btn btn-success form-group btn_print" data-testid="btn-print" printSectionId="print-section" onclick="window.print();">
            {{ 'Common.Print' | translate }}
          </button>
          <button class="btn btn-danger form-group btn_close" data-testid="btn-exit" (click)="close()" type="button">
            {{'Common.Close' | translate}}
          </button>
        </form-actions>
        <form-body>
          <div class="col-md-12" id="print-section">
            <div class="table-responsive mt-2">
              <table class="table datatablePrint table2excel" border="1" data-tableName="Test Table 2" id="exportTable" data-testid="tbl-export">
                <thead data-testid="thead-export">
                  <tr>
                    @for (field of pageFields; track field; let j = $index) {
                      <th [attr.data-testid]="'th-'+ field.columnName" style="border-color:#ccc !important; border-collapse:collapse !important; border:1px solid #ccc !important;text-align:left !important;margin-right:20px;">
                        @if (j === 0) {
                          <span><b>#</b></span>
                        }
                        @if (field.jT7Localization !== null && field.jT7Localization !== '') {
                          <span>
                            {{ field.jT7Localization |translate }}
                          </span>
                        }
                        @if (j > 0) {
                          <span>
                            <b>
                              @if (field.jT7Localization === null || field.jT7Localization === '') {
                                <span>
                                  {{ field.columnHeader }}
                                </span>
                              }
                            </b>
                          </span>
                        }
                        @if (j > 0) {
                          <span class="sort">
                          </span>
                        }
                      </th>
                    }
                  </tr>
                </thead>
                <tbody data-testid="tbody-export">
                  @for (data of listOfData; track data; let i = $index) {
                  <tr>
                    @for (field of pageFields; track field) {
                    @for (propertyName of properties; track propertyName) {
                    @if (field.columnName.toLowerCase() === propertyName.toLowerCase();) {
                    @if (field.isSystemRefId>0) {
                    <td style="border-color:#ccc !important; border-collapse:collapse !important; border:1px solid #ccc !important">
                      {{i + 1}}
                    </td>
                    }
                    @if (field.isSystemRefId === 0 && field.columnName !== 'AgencyData') {
                    <td style="border-color:#ccc !important; border-collapse:collapse !important; border:1px solid #ccc !important" [innerHTML]='[field.columnType?.toLowerCase() === "date" ? (data[propertyName] | date): field.columnType?.toLowerCase() === "time" ? (data[propertyName] | date : "HH:mm") : ((field.columnName==="VisibleTo")? ("External:"+data.VisibleTo.external +",Internal:"+data.VisibleTo.internal+",Agency:"+data.VisibleTo.agency) :  data[propertyName])] '>
                    </td>
                    }
                    @if (field.isSystemRefId === 0 && field.columnName === 'AgencyData') {
                    <td>
                      @if (data.AgencyData.result === 'Correct') {
                      <span> <app-svg-icon [type]="'complete_check'" [className]="'svg-completed'"> </app-svg-icon></span>
                      }
                      @if (data.AgencyData.result === 'Incorrect') {
                      <span class="Incorrect"> <app-svg-icon [type]="'Cross'" [className]="'svg-completed'"> </app-svg-icon></span>
                      }
                    </td>
                    }
                    }
                    }
                    }
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </form-body>
      </app-jt-modal-hor-form>
    </jt-modal-page>
  </div>

  <app-excel-export-modal></app-excel-export-modal>


</ng-container>



